import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Gavel } from './Gavel';

export type SliderProps = {
  onChange: (value: string) => void;
  max: number;
  min: number;
  value: number;
};

type InputProps = {
  max: number;
  min: number;
  value: number;
};

const thumbStyles = css`
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: ${({ theme }) => theme.colors.primary.white};
  background-image: ${({ theme }) => `url('data:image/svg+xml;utf8,
    ${Gavel(theme.colors.system.systemBlue.replace('#', '%23'))}')`};
  background-repeat: no-repeat;
  background-position: center;
  border: none;
  border-radius: 100%;
  box-shadow: 0 2px 4px 0px
    ${({ theme }) => theme.colors.neutrals.solidGrays[6]};
  height: 40px;
  left: 0;
  margin: ${({ theme }) => theme.spacings[1].rem} 0;
  outline: none;
  position: relative;
  width: 40px;
`;

const Input = styled.input<InputProps>`
  appearance: none;
  margin: ${({ theme }) => theme.spacings[4].rem} 0;
  outline: none;
  width: 100%;

  &::-webkit-slider-runnable-track {
    background: ${({ theme }) => theme.colors.system.systemBlue};
    background-image: ${({ max, min, theme, value }) => {
      const ratio = ((value - min) / (max - min)).toFixed(2);

      return `-webkit-gradient(linear, left top, right top, 
        color-stop(${ratio}, ${theme.colors.primary.graysBlue}), 
        color-stop(${ratio}, ${theme.colors.neutrals.solidGrays[6]}))`;
    }};
    border-radius: 8px;
    height: 10px;
  }

  &::-moz-range-track,
  &::-moz-range-progress {
    background: ${({ theme }) => theme.colors.neutrals.solidGrays[6]};
    border-radius: 8px;
    height: 10px;
  }

  &::-moz-range-progress {
    background: ${({ theme }) => theme.colors.system.systemBlue};
  }

  &::-webkit-slider-thumb {
    ${thumbStyles}
    top: 50%;
    transform: translateY(-60%);
  }

  &::-moz-range-thumb {
    ${thumbStyles}
    border: none;
  }
`;

export const Slider: React.FC<SliderProps> = ({
  onChange,
  min,
  max,
  value,
  ...props
}) => {
  const [point, setPoint] = useState(0);

  useEffect(() => {
    if (value) setPoint(value);
  }, [value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div {...props}>
      <Input
        max={max}
        min={min}
        onChange={handleChange}
        type="range"
        value={point}
      />
    </div>
  );
};
